import {
  FETCH_ESCALATION_COUNT_SUCCESS,
  UPDATE_ESCALATION_COUNT,
  UPDATE_IDLE_DRIVER_COUNT
} from '../actions/escalationCount';

const initialState = {
  apiCount: 0,
  idleCount: 0,
  escalationCount: 0 // Combined total
};

export default function escalationCountReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ESCALATION_COUNT_SUCCESS:
    case UPDATE_ESCALATION_COUNT:
      return {
        ...state,
        apiCount: action.payload,
        escalationCount: action.payload + state.idleCount
      };
      
    case UPDATE_IDLE_DRIVER_COUNT:
      return {
        ...state,
        idleCount: action.payload,
        escalationCount: state.apiCount + action.payload
      };
    
    default:
      return state;
  }
}
